<template>
  <v-layout align-center justify-center class="auth">
    <v-flex xs11 sm6 md5>
      <v-card>
        <v-card-text>
          <v-layout>
            <v-flex xs12 text-xs-center>
              <img
                :src="this.$store.state.brand.brand.logo"
                alt="Logo"
                height="56px"
              />
            </v-flex>
          </v-layout>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <br />
                <p class="text-xs-center">
                  INGRESA TU CORREO PARA RECUPERAR TU CONTRASEÑA
                </p>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="email"
                  label="Correo *"
                  prepend-icon="email"
                  required
                ></v-text-field>
                <div id="recaptcha-password-reset" class="recaptcha"></div>
              </v-flex>
              <v-flex xs12>
                <v-btn
                  :disabled="!reCAPTCHA || !email"
                  block
                  color="primary"
                  @click="sendPasswordResetEmail"
                  >RECUPERAR CONTRASEÑA</v-btn
                >
              </v-flex>
              <v-flex xs6 class="text-xs-left">
                <nuxt-link to="register">¿No tienes cuenta?</nuxt-link>
              </v-flex>
              <v-flex xs6 class="text-xs-right">
                <nuxt-link to="login">¿Ya tienes cuenta?</nuxt-link>
              </v-flex>
              <br />
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-flex>
    <v-snackbar
      v-model="snackbar.show"
      :top="true"
      :right="true"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :multi-line="snackbar.mode === 'multi-line'"
      :vertical="snackbar.mode === 'vertical'"
    >
      {{ snackbar.text }}
      <v-btn dark flat @click.native="snackbar.show = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import axios from 'axios'
import async from 'async'
import UserService from '@/services/UserService'

export default {
  data() {
    return {
      reCAPTCHA: '',
      email: '',
      snackbar: {
        show: false,
        color: '',
        mode: '',
        timeout: 6000,
        text: '',
        right: '',
        top: ''
      }
    }
  },
  mounted() {
    const self = this
    window.recaptchaVerifierPasswordReset = new firebase.auth.RecaptchaVerifier(
      'recaptcha-password-reset',
      {
        callback() {
          self.reCAPTCHA = true
        },
        'expired-callback'() {
          self.reCAPTCHA = false
        },
        size: this.$vuetify.breakpoint.smAndDown ? 'compact' : 'normal'
      }
    )
    window.recaptchaVerifierPasswordReset.render().then(function(widgetId) {
      window.recaptchaWidgetPasswordResetId = widgetId
    })
  },
  methods: {
    sendPasswordResetEmail() {
      this.$wait.start('full')
      async.waterfall(
        [
          callback => {
            UserService.emailExist({ email: this.email.trim() })
              .then(response => {
                if (parseInt(response.total) > 0) {
                  callback(null)
                } else {
                  // eslint-disable-next-line
                  callback('error', {
                    message:
                      'El email ingresado no existe. Por favor verificalo.'
                  })
                }
              })
              .catch(error => {
                callback(error, {
                  message:
                    'El email no pudo ser enviado. Por favor intenta nuevamente'
                })
              })
          },
          callback => {
            UserService.getByEmail({ email: this.email.trim() })
              .then(res => {
                callback(null, res.uid)
              })
              .catch(err => {
                callback(err, {
                  message:
                    'El email no pudo ser enviado. Ocurrió un error al obtener el usuario.'
                })
              })
          },
          (uid, callback) => {
            axios
              .post('/api/create-token', {
                uid,
                currentUrl: this.$store.state.currentUrl,
                mode: 'resetPassword'
              })
              .then(res => {
                callback(null, res.data)
              })
              .catch(err => {
                callback(err, {
                  message:
                    'El email no pudo ser enviado. Ocurrió un error al crear el token.'
                })
              })
          },
          (linkToChangePass, callback) => {
            axios
              .post('/api/send-email', {
                personalizations: [
                  {
                    to: this.email.trim(),
                    dynamic_template_data: {
                      user: this.email.trim(),
                      title: 'Restablece tu contraseña',
                      link: linkToChangePass,
                      content: `Visita este vínculo para restablecer la contraseña para tu cuenta ${this.email}`,
                      subject: 'Restablece tu contraseña',
                      button: 'Continuar'
                    }
                  }
                ]
              })
              .then(() => {
                callback(null)
              })
              .catch(err => {
                callback(err, {
                  message:
                    'El email no pudo ser enviado. Por favor intenta nuevamente'
                })
              })
          }
        ],
        (err, message) => {
          if (err) {
            this.snackbar.show = true
            this.snackbar.text = message.message
            this.snackbar.color = 'error'
          } else {
            this.snackbar.show = true
            this.snackbar.text =
              'Correo de restablecimiento de contraseña enviado con éxito.'
            this.snackbar.color = 'success'
          }
          this.$wait.end('full')
        }
      )
    }
  }
}
</script>
